import { Avatar, BottomSheet, Button, Typography } from '@/ui-kit/';
import styles from './user-info-chat.module.scss';
import { differenceInYearsResult } from '@/utils/difference-in-years-result';
import { generatePath } from 'react-router-dom';
import { routesApp } from '@/constans/routes';
import { useNavigate } from 'react-router';
import WebApp from '@twa-dev/sdk';
import { useVibration } from '@/store/useVibration';
import { PremiumIcon, VerifiedAccountIcon } from '@/assets/icons';
import { useState } from 'react';
import { useAuth } from '@/store/useAuth';
import { PremiumBottomsheet } from '../premium-bottomsheet';
import { getProfileNameAndAge } from '@/utils/msgs';
import { Profile } from '@/types/profile';
import { useTranslation } from 'react-i18next';

interface Props {
    userId?: number;
    status?: 'online' | 'offline';
    photo?: string;
    name?: string | null;
    ageDate?: string | null;
    isVerified: boolean;
    isVerificationInProgress: boolean;
    isPaid?: boolean;
    gender: 'male' | 'female' | null | undefined;
    profile?: Profile | null;
    isBanned: boolean;
}

export const UserInfoChat: React.FC<Props> = ({
    userId,
    status = 'online',
    photo,
    name,
    ageDate,
    isVerified,
    isVerificationInProgress,
    isPaid,
    gender,
    isBanned,
    profile,
}) => {
    const navigate = useNavigate();

    const { isVibrationEnabled } =
        useVibration(state => state);

    const toUserProfile = () => {
        navigate(generatePath(routesApp.profileView, { id: String(userId) }));
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    };

    const [isVerificationModalOpen, setIsVerificationModalOpen] =
        useState(false);

    const [isPremiumModalOpen, setIsPremiumModalOpen] =
        useState(false);

    const { t } = useTranslation();

    return (
        <div
            className={styles.wrapper}
            onClick={() => toUserProfile()}>
            <div className={styles.avatarWrap}>
                <Avatar
                    src={photo}
                    alt="avatar"
                    size={44} />
                {status === 'online' && <span className={styles.status}></span>}
            </div>
            <div className={styles.details}>
                <div className={styles.nameAndVerificationStatusInfo}>
                    {/* #rt15368 unset font-weight bold */}
                    <Typography
                        variant="span"
                        typeColor="brown"
                        className={styles.detailsName}>
                        {
                            getProfileNameAndAge(profile)
                        }
                    </Typography>
                    {
                        isVerified &&
                        <VerifiedAccountIcon
                            width={20}
                            height={20}
                            className={styles.verificationStatusInfo}
                            onClick={(e) => {
                                e.stopPropagation()
                                setIsVerificationModalOpen(true)
                            }} />
                    }
                    {
                        isPaid &&
                        <PremiumIcon
                            width={20}
                            height={20}
                            onClick={(e) => {
                                e.stopPropagation()
                                setIsPremiumModalOpen(true)
                            }} />
                    }
                </div>
                {
                    isVerificationInProgress &&
                    <Typography className={styles.bannedAccountProfileLabel} variant="span">
                        {t('msgs.user_temp_unable_send_msg')}
                    </Typography>
                }
                {
                    isBanned ?
                        <Typography className={styles.bannedAccountProfileLabel} variant="span">
                            {t('account_banned')}
                        </Typography>
                    :
                        <Typography
                            fontWeight="bold"
                            variant="span"
                            typeColor="orange">
                            {status}
                        </Typography>
                }
            </div>
            <BottomSheet
                overlayClassName={styles.bottomsheetOverlay}
                isOpen={isVerificationModalOpen}
                isDeskorTop={false}
                onClose={() => setIsVerificationModalOpen(false)}>
                <div className={styles.verificationModalContent}>
                    <div className={styles.verificationModalContentIcon}>
                        <Avatar
                            src={photo}
                            size={96} />
                        <VerifiedAccountIcon
                            className={styles.verificationModalContentIconVerification}
                            width={28}
                            height={28} />
                    </div>
                    <div className={styles.verificationModalContentHeader}>
                        <Typography
                            className={styles.verificationModalContentHeaderTitle}
                            variant={'h5'}
                            fontWeight={'bold'}>
                            {
                                t('user_pass_verification', { name, context: gender })
                            }
                        </Typography>
                        <Typography
                            className={styles.verificationModalContentHeaderDesc}>
                            {t('verification_desc')}
                        </Typography>
                    </div>
                    <div className={styles.verificationModalContentFootnote}>
                        <Button
                            typeColor="orange"
                            className={styles.verificationModalContentFootnoteBtn}
                            onClick={() => setIsVerificationModalOpen(false)}>
                            {t('ok_tertiary')}
                        </Button>
                    </div>
                </div>
            </BottomSheet>

            <PremiumBottomsheet
                photo={photo}
                name={name}
                isPremiumModalOpen={isPremiumModalOpen}
                setIsPremiumModalOpen={setIsPremiumModalOpen} />
        </div>
    );
};
